<script>
   
</script>
<div>
    <div class="container mx-auto pt-20 p-4 rounded-2xl">
      <h1 class="font-bold text-4xl">About TMTPOS</h1>
      <p></p>


        <div class="bg-gray-100 p-4 rounded-lg mt-4 text-gray-700">
          Now that culture seems to be seeping into more and more workplaces, as young founders and tech workers try to
          capitalize on the rise of AI. The CEO of the $10 billion AI startup Cognition has talked openly about the
          intense work ethic expected at his company.

          Ge.
          123
        </div>
    </div>
</div>